import React, { useState, useEffect } from 'react';
import {
  Popover,
  Paper,
  FormControlLabel,
  Checkbox,
  List,
  ListItem,
  Button,
  Box,
  Typography
} from '@mui/material';

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: 'right' | 'left' | 'center';
  format?: (value: any) => string;
  numeric?: boolean;
  isDate?: boolean;
}

interface ColumnVisibilityPickerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  columns: Column[];
  visibleColumns: string[];
  onVisibilityChange: (visibleColumns: string[]) => void;
  anchorEl: HTMLElement | null;
}

const ColumnVisibilityPicker: React.FC<ColumnVisibilityPickerProps> = ({
  open,
  setOpen,
  columns,
  visibleColumns,
  onVisibilityChange,
  anchorEl
}) => {
  const [tempVisibleColumns, setTempVisibleColumns] = useState<string[]>(visibleColumns);

  useEffect(() => {
    setTempVisibleColumns(visibleColumns);
  }, [visibleColumns]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleColumnToggle = (columnId: string) => {
    const newVisibleColumns = tempVisibleColumns.includes(columnId)
      ? tempVisibleColumns.filter(id => id !== columnId)
      : [...tempVisibleColumns, columnId];
    
    setTempVisibleColumns(newVisibleColumns);
    onVisibilityChange(newVisibleColumns);
  };



  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: { minWidth: 250, maxHeight: 400, overflow: 'hidden' }
      }}
    >
      <Paper sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold' }}>
          Column Visibility
        </Typography>
        
        <List sx={{ maxHeight: 250, overflow: 'auto', '&::-webkit-scrollbar': { display: 'none' }, msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
          {columns.map((column) => (
            <ListItem key={column.id} dense sx={{ py: 0.5 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempVisibleColumns.includes(column.id)}
                    onChange={() => handleColumnToggle(column.id)}
                    size="small"
                  />
                }
                label={column.label}
                sx={{ width: '100%' }}
              />
            </ListItem>
          ))}
        </List>
        

      </Paper>
    </Popover>
  );
};

export default ColumnVisibilityPicker; 